import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { SetFormPristine } from '@ngxs/form-plugin';
import { routeNames } from '@shared/models';
import { SharedService } from '@shared/services';
import { MazcardFile } from '@app/models';
import { PortalService } from '@app/services';
import { ListState } from '@app/store/list.state';
import * as actionsList from '@app/store/list.actions';

@Injectable({
  providedIn: 'root',
})
export class PropertiesMazcardService {
  constructor(
    private store: Store,
    private sharedService: SharedService,
    private portalService: PortalService
  ) {}

  select(mazId, fileNumber, navigate = true) {
    if (!mazId || !fileNumber) return;
    const fileSelected = this.store.selectSnapshot(ListState.fileSelected);
    if (fileSelected && fileSelected.mazNr === mazId && fileSelected.file === fileNumber) return;

    let callback;
    switch (fileNumber) {
      case routeNames.newFileID:
        callback = this.triggerAddMazNewFile.bind(this);
        break;
      case routeNames.draftFileID:
        callback = this.triggerSelectDraft.bind(this);
        break;
      default:
        callback = this.triggerSelectFile.bind(this);
        break;
    }

    const params = [mazId, fileNumber, navigate];
    const pending = this.store.selectSnapshot(ListState.newFilePending);

    pending
      ? this.portalService.checkNewFilePending(params, callback)
      : this.portalService.checkChangesPending(params, callback);
  }

  triggerSelectFile(mazId: string, fileNumber: string, navigate = true) {
    // this.loadFileDetails();
    this.store.dispatch([
      new SetFormPristine('file.mazForm'),
      new actionsList.SetMazcardSelected(mazId),
      new actionsList.SetFileSelected(<MazcardFile>{
        mazNr: mazId,
        file: fileNumber,
      }),
    ]);

    if (navigate) this.sharedService.navigatePreserve([mazId, fileNumber]);
  }

  triggerAddMazNewFile(mazId: string, fileNumber: string, navigate = true) {
    this.store.dispatch(new actionsList.AddNewFile(mazId));
    this.triggerSelectFile(mazId, fileNumber, navigate);
  }

  triggerSelectDraft(mazId: string, fileNumber: string, navigate = true) {
    this.store.dispatch([
      new SetFormPristine('file.mazForm'),
      new actionsList.SetMazcardSelected(mazId),
      new actionsList.SetDraftSelected(<MazcardFile>{
        mazNr: mazId,
      }),
    ]);

    if (navigate) this.sharedService.navigatePreserve([mazId, fileNumber]);
  }
}
